import React, {useContext} from "react";
import {Grid, TextField, Typography} from "@leap4/frontend";
import {AdvertiserLoginContext} from "./AdvertiserLoginContext";
import {PartnerContainer} from "./AddEditAL/Partners.container";

export interface IDetailsFormProps {
    mode: "create" | "edit"
}



const DetailsForm = (props: IDetailsFormProps) => {
    const {advertiserLogin} = useContext(AdvertiserLoginContext);

    return (
        <>
            <Grid margin={"10px"}>
                <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                    ADVERTISER LOGINS
                </Typography>
            </Grid>
            <Grid container gap={"10px"}>
                {(advertiserLogin?.publisherName + ' - ' + advertiserLogin?.advertiserName) && <Grid item width={"100%"}>
                    <TextField fullWidth label={"Publisher - Advertiser"} disabled
                               value={(advertiserLogin?.publisherName + ' - ' + advertiserLogin?.advertiserName)}/>
                </Grid>}
                <Grid item width='70%'>
                </Grid>
            </Grid>
            <Grid margin={"20px"} item width='95%'>
                <PartnerContainer
                    currentAdvertiserLogin={advertiserLogin}
                />
            </Grid>
        </>
    )
}
export {DetailsForm}
